// src/api/auth.api.js
import {
  apiFetch,
  setToken,
  clearToken,
  getCurrentUser,
  setCurrentUser,
  clearCurrentUser,
} from './core.js'

/* =========================
 * AUTH
 * ========================= */

/**
 * ✅ Login
 * - Envoie TOUJOURS "username" + "password" au backend
 * - Compat: si tu passes un email, on l’envoie dans username (backend gère username OR email)
 */
export async function login(username, password) {
  const data = await apiFetch('/api/auth/login', {
    method: 'POST',
    body: { username, password },
  })

  if (data?.token) {
    setToken(data.token)
  } else {
    clearToken()
  }
  setCurrentUser(data.user || null)

  return data
}

/**
 * ✅ Logout (best effort)
 * - Même si /logout n’existe pas côté backend, on nettoie côté front
 */
export async function logout() {
  try {
    await apiFetch('/api/auth/logout', { method: 'POST' })
  } catch {
    // ignore
  }
  clearToken()
  clearCurrentUser()
}

export function isAuthenticated() {
  return !!getCurrentUser()
}

export function getAuthUser() {
  return getCurrentUser()
}

/* =========================
 * FETCH CURRENT USER
 * ========================= */
export async function fetchMe() {
  const user = await apiFetch('/api/auth/me')
  setCurrentUser(user || null)
  return user
}

export async function verifyEmail(token, tenantId = null) {
  return apiFetch('/api/auth/verify-email', {
    method: 'POST',
    body: {
      token,
      ...(tenantId ? { tenant_id: tenantId } : {}),
    },
  })
}

export async function resendVerification(email) {
  return apiFetch('/api/auth/resend-verification', {
    method: 'POST',
    body: { email },
  })
}
